module.exports = __webpack_public_path__ + "img/ex_card.994ec695.jpg";